<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import service from '../../../../domain/grv/services'
  import {isArray, debounce} from 'lodash'
  import moment from 'moment'
  import BtnCheckPossui from './CheckPossui'
  import Vue from 'vue'
  import PatenteService from '../../../../domain/policia-civil/patentes/services/patentes'
  import UnidadePolicialService from '../../../../domain/policia-civil/unidade-policial/services/unidade-policial'
  import SeguradoraService from '../../../../domain/policia-civil/seguradora/services/seguradora'
  import PolicialService from '../../../../domain/policia-civil/policial/services/policial'
  import estadosBr from '../../../_default/utils/estados-brasileiros'
  import AtendentePatioService from '../../../../domain/policia-civil/atendente-patio/services/atendente-patio'
  import TiposGrvService from '../../../../domain/policia-civil/tipo-grv/services/tipo-grv'
  import ReintegradoraService from '../../../../domain/policia-civil/reintegrador/services/reintegrador'
  import LocadoraService from '../../../../domain/policia-civil/locadora/services/locadora'
  import {GRV_POLICIA_CIVIL} from '../../../../domain/grv/helpers/tipos-grv'
  import TiposDevolucaoService from '../../../../domain/policia-civil/tipo-devolucao/services/tipo-devolucao'
  import SituacaoApreensaoService from '../../../../domain/policia-civil/situacao-apreensao/services/situacao-apreensao'
  import EstadoVeiculoService from '../../../../domain/policia-civil/estado-veiculo/services/estado-veiculo'
  import AvariaService from '../../../../domain/policia-civil/avaria/services/avaria'
  import {updatePlacaAlterada} from '../../../../domain/policia-civil/pericia/services/pericia'

  const POSSUI = '1'
  const NAO_POSSUI = '2'
  const NAO_MARCA = '5'

  let templateLacre = {id: null, numero: null, violado: false}
  let templateArquivo = {id: null, nomeArquivo: null, nomeOriginal: null, descricao: null, tipo: null, arquivo: null}
  let templateEquipamento = {id: null, possui: true, equipamento: {id: null, nome: null}}

  export default {
    components: {
      BtnCheckPossui
    },
    nome: 'ggv-roubo-furto',
    directives: {mask},
    data () {
      return {
        baseFotoUrl: `${process.env.API_URL}/api/public/grv-foto`,
        isGgv: false,
        dataRequired: {
          equipamentos: []
        },
        dataRequiredLoaded: false,
        extraModel: {
          dataApreensao: null,
          horaApreensao: null,
          dataRemocao: null,
          horaRemocao: null
        },
        data: {
          id: null,
          numero: null,
          ano: null,
          bairroApreensao: null,
          chassi: null,
          numeroMotor: null,
          chavesVeiculo: 1,
          numeroChave: null,
          cidadeApreensao: null,
          cidadeCondutor: null,
          // codigoInfracao: null,
          equipamentos: [],
          // motivoInfracaoOutros: null,
          marca: null,
          modelo: null,
          cor: null,
          vaga: null,
          cpfCondutor: null,
          data: null,
          dataApreensao: null,
          enderecoApreensao: null,
          enderecoCondutor: null,
          estadoCondutor: null,
          lacres: [
            JSON.parse(JSON.stringify(templateLacre)),
            JSON.parse(JSON.stringify(templateLacre)),
            JSON.parse(JSON.stringify(templateLacre))
          ],
          matriculaAgenteApreensor: null,
          nivelCombustivel: null,
          nomeAgenteApreensor: null,
          nomeCondutor: null,
          // numeroAutoInfracao: null,
          observacoes: null,
          orgaoEmissorRgCondutor: null,
          placa: null,
          renavam: null,
          rgCondutor: null,
          telefoneCondutor: null,
          // tipoOperacao: 2,
          tipoRemocao: 2,
          volumesInteriorVeiculo: null,
          comRubrica: null,
          rubrica: null,
          comAssinaturaCondutor: null,
          assinaturaCondutor: null,
          comAssinaturaTestemunha: null,
          condutorPresente: null,
          ufApreensao: null,
          orgaoApreensor: null,
          reboque: null,
          reboquista: null,
          contrato: null,
          bemCategoria: null,
          patio: null,
          kmForaDaCidade: null,
          kmInicialDoReboque: 0,
          complementoApreensao: null,
          complementoCondutor: null,
          codigoGrv: null,
          liberarPorDecisaoJudicial: false,
          liberarPorPrensa: false,
          liberarPorRouboFurto: false,
          arquivos: [
            JSON.parse(JSON.stringify(templateArquivo))
          ],
          /* grv roubo furto */
          // statusProcesso: null,
          dpOrigem: null,
          roOrigem: null,
          dataRoOrigem: null,
          roApreensaoRecuperacao: null,
          naoEmplacado: false,
          possuiPlacaOriginal: false,
          semPlaca: false,
          comRodas: false,
          delito: null,
          localizacaoAtual: null,
          veiculoNaoIdentificado: false,
          periciaRealizada: false,
          formularioOperadora: null,
          formularioPatio: null,
          recebedorPatio: null,
          recebedorCpf: null,
          recebedorRg: null,
          trancado: false,
          indenizado: false,
          veiculoSegurado: false,
          seguradora: null,
          apoliceSinistro: null,
          tipoGev: null,
          observacoesGev: null,
          dataEntregaDevolucao: null,
          tipoDevolucao: null,
          nomeDevolucao: null,
          cpfDevolucao: null,
          telefoneDevolucao1: null,
          telefoneDevolucao2: null,
          telefoneDevolucao3: null,
          telefoneDevolucao4: null,
          entregadorPatio: null,
          policialRecebedorPatio: null,
          unidadePolicialRecebedorPatio: null,
          dataContatoReintegracao: null,
          transferirProcesso: false,
          patioTransferencia: null,
          empresaContratante: null,
          reintegradora: null,
          observacoesReintegracao: null,
          policialApreensao: null,
          seguradoraAssociados: null,
          locadora: null,
          placaOriginal: null,
          situacaoApreensao: null,
          dataSolicitacaoReboque: null,
          dataPrevisaoChegada: null,
          dataChegadaRemocao: null,
          dataSaidaRemocao: null,
          dataEntradaPatio: null,
          dataSaidaPatio: null,
          // kmForaDaCidadeReboquePatio: null,
          // kmInicialDoReboquePatio: 0,
          enderecoRemocao: null,
          bairroRemocao: null,
          ufRemocao: null,
          complementoRemocao: null,
          cidadeRemocao: null,
          kmFinalDoReboque: 0,
          unidadePolicialApreensao: null,
          patentePolicialApreensao: null,
          observacoesReboque: null,
          observacoesEquipamentos: null,
          comAssinaturaPolicial: false,
          comAssinaturaReboquista: false,
          placaAlterada: null,
          dataPlacaAlterada: null,
          tipoGgv: null,
          estadoVeiculo: null,
          observacoesGgv: null,
          comChave: null
        },
        ggv: {
          conforme: false
        },
        edit: false,
        isLoading: false,
        cadastroError: null,
        atualizadoSucesso: null,
        statusOptions: [
          {label: 'Ativo', value: 1, class: 'btn-default'},
          {label: 'Inativo', value: 0, class: 'btn-default'},
          {label: 'Cancelado', value: -1, class: 'btn-default'}
        ],
        estadosBr,
        showFormPericia: false,
        showFormPolicial: false,
        policialSelecionado: {
          nome: null,
          matricula: null
        },
        patentes: [],
        unidadesPoliciais: [],
        seguradoras: [],
        policiais: [],
        atendentesPatio: [],
        tiposGrv: [],
        reintegradoras: [],
        locadoras: [],
        tiposDevolucao: [],
        situacoesApreensao: [],
        avarias: [],
        estadosVeiculo: [],
        filtro: '',
        showOptionsAutocomplete: false,
        loading: false,
        dataRequiredFiltros: [
          'policiais',
          'avarias',
          'patentes',
          'unidadesPoliciais',
          'seguradoras',
          'atendentesPatio',
          'tiposGrv',
          'reintegradoras',
          'locadoras',
          'tiposDevolucao',
          'situacoesApreensao',
          'estadosVeiculo'
        ]
      }
    },
    computed: {},
    created () {
      /* this.carregarAvarias()
      *this.carregarPatentes()
      this.carregarUnidadesPoliciais()
      *this.carregarSeguradoras()
      this.carregarAtendentesPatio()
      this.carregarTiposGrv()
      *this.carregarReintegradoras()
      *this.carregarLocadoras()
      *this.carregarTiposDevolucao()
      *this.carregarSituacoesApreensao()
      this.carregarEstadosVeiculo() */
    },
    mounted () {
      this.$loaderOverlay.open().message('Carregando dados relacionados')
      const montaDataRequiredFilters = () => {
        let mount = ''
        for (let value of this.dataRequiredFiltros) {
          mount += `&${value}=true`
        }
        return mount
      }
      service.dataRequired(GRV_POLICIA_CIVIL, montaDataRequiredFilters())
        .then((response) => {
          console.log('dataRequired: ', response.data)
          this.$loaderOverlay.hide()
          this.dataRequiredLoaded = true
          this.dataRequired = response.data
          if (isArray(this.dataRequired.equipamentos) && this.dataRequired.equipamentos.length > 0) {
            this.dataRequired.equipamentos = this.dataRequired.equipamentos.filter(equipamento => equipamento.policiaCivil)
            for (let i = 0; i < this.dataRequired.equipamentos.length; i++) {
              // this.$set(this.dataRequired.equipamentos[i], 'checked', false)
              // this.$set(this.dataRequired.equipamentos[i], 'possui', false)
              Vue.util.defineReactive(this.dataRequired.equipamentos[i], 'checked', false)
              Vue.util.defineReactive(this.dataRequired.equipamentos[i], 'possui', NAO_MARCA)
            }
          }
          // this.data.numero = this.dataRequired.sequencialGrv

          this.start()
          console.log(response)
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    activated () {
    },
    destroyed () {
    },
    methods: {
      start () {
        if (this.$route.params.id && this.$route.params.id !== 'registrar') {
          this.edit = true
          this.$loaderOverlay.open().message('Carregando GGV')
          if (typeof this.$route.query.ggv !== 'undefined') {
            this.isGgv = true
          }
          service.find(this.$route.params.id, this.isGgv)
            .then((response) => {
              this.$loaderOverlay.hide()
              let data = response.data
              data.reboque = data.reboque ? data.reboque.id : null
              data.orgaoApreensor = data.orgaoApreensor ? data.orgaoApreensor.id : null
              data.reboquista = data.reboquista ? data.reboquista.id : null
              data.bemCategoria = data.bemCategoria ? data.bemCategoria.id : null
              data.patio = data.patio ? data.patio.id : null
              data.contrato = data.contrato ? data.contrato.id : null
              // data.reboquePatio = data.reboquePatio ? data.reboquePatio.id : null
              // data.reboquistaPatio = data.reboquistaPatio ? data.reboquistaPatio.id : null

              let dataRemocao = JSON.parse(JSON.stringify(data.data))
              this.extraModel.dataRemocao = dataRemocao ? moment(dataRemocao.date).format('L') : null
              this.extraModel.horaRemocao = dataRemocao ? moment(dataRemocao.date).format('LT') : null
              let dataApreensao = JSON.parse(JSON.stringify(data.dataApreensao))
              this.extraModel.dataApreensao = dataApreensao ? moment(dataApreensao.date).format('L') : null
              this.extraModel.horaApreensao = dataApreensao ? moment(dataApreensao.date).format('LT') : null

              const formataData = date => date ? moment(date.date).format('L LT') : null

              data.policialApreensao = data.policialApreensao ? data.policialApreensao.id : null
              data.policialRecebedorPatio = data.policialRecebedorPatio ? data.policialRecebedorPatio.id : null
              data.dataRoOrigem = formataData(data.dataRoOrigem)
              data.dataEntregaDevolucao = formataData(data.dataEntregaDevolucao)
              data.dataContatoReintegracao = formataData(data.dataContatoReintegracao)
              data.dataSolicitacaoReboque = formataData(data.dataSolicitacaoReboque)
              data.dataPrevisaoChegada = formataData(data.dataPrevisaoChegada)
              data.dataChegadaRemocao = formataData(data.dataChegadaRemocao)
              data.dataSaidaRemocao = formataData(data.dataSaidaRemocao)
              data.dataEntradaPatio = formataData(data.dataEntradaPatio)
              data.dataSaidaPatio = formataData(data.dataSaidaPatio)
              data.dataPlacaAlterada = formataData(data.dataPlacaAlterada)
              data.seguradoraAssociados = data.seguradoraAssociados ? data.seguradoraAssociados.id : null
              data.locadora = data.locadora ? data.locadora.id : null
              data.unidadePolicialRecebedorPatio = data.unidadePolicialRecebedorPatio ? data.unidadePolicialRecebedorPatio.id : null
              data.seguradora = data.seguradora ? data.seguradora.id : null
              data.tipoGev = data.tipoGev ? data.tipoGev.id : null
              data.tipoGgv = data.tipoGgv ? data.tipoGgv.id : null
              data.tipoDevolucao = data.tipoDevolucao ? data.tipoDevolucao.id : null
              data.entregadorPatio = data.entregadorPatio ? data.entregadorPatio.id : null
              data.patioTransferencia = data.patioTransferencia ? data.patioTransferencia.id : null
              data.reintegradora = data.reintegradora ? data.reintegradora.id : null
              data.situacaoApreensao = data.situacaoApreensao ? data.situacaoApreensao.id : null
              data.patentePolicialApreensao = data.patentePolicialApreensao ? data.patentePolicialApreensao.id : null
              data.unidadePolicialApreensao = data.unidadePolicialApreensao ? data.unidadePolicialApreensao.id : null
              data.estadoVeiculo = data.estadoVeiculo ? data.estadoVeiculo.id : null
              data.recebedorPatio = data.recebedorPatio ? data.recebedorPatio.id : null

              if (data.policialRecebedorPatio) {
                this.carregarPoliciais(data.policialRecebedorPatio, true)
              }

              /* if (isArray(data.equipamentos) && data.equipamentos.length > 0) {
                this.dataRequired.equipamentos.forEach((e) => {
                  let find = data.equipamentos.findIndex((e1) => e1.equipamento.id === e.id)
                  if (typeof find !== 'undefined' && find !== -1) {
                    e.checked = true
                    e.possui = data.equipamentos[find].equipamento.possui
                  }
                })
              } */
              if (isArray(data.equipamentos) && data.equipamentos.length > 0) {
                data.equipamentos = data.equipamentos.map(item => {
                  item.equipamento.possui = item.possui
                  if (item.avaria) {
                    item.equipamento.avaria = item.avaria.id
                  }
                  return item.equipamento
                })
                this.dataRequired.equipamentos.forEach((e) => {
                  let find = data.equipamentos.findIndex((e1) => e1.id === e.id)
                  if (typeof find !== 'undefined' && find !== -1) {
                    e.checked = true
                    e.possui = data.equipamentos[find].possui
                    e.avaria = data.equipamentos[find].avaria
                    data.equipamentos[find] = e
                  }
                })
              }

              this.data = data
              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
        }
      },
      submit () {
        if (this.isGgv) {
          let confirm = window.confirm('Tem certeza que deseja gerar a GGV?')
          if (!confirm) {
            return
          }
        }
        this.cadastroError = null
        this.$loaderOverlay.open().message('Processando')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde, registrando GGV...')
        }, 1000)
        let data = JSON.parse(JSON.stringify(this.data))
        data.data = this.extraModel.dataRemocao + ' ' + this.extraModel.horaRemocao
        data.dataApreensao = this.extraModel.dataApreensao + ' ' + this.extraModel.horaApreensao
        if (this.isGgv) {
          data.isGgv = true
          data.ggv = this.ggv
        }
        data.equipamentos = data.equipamentos.map(equip => {
          equip.possui = equip.possui ? POSSUI : NAO_POSSUI
          return equip
        })
        if (this.policialSelecionado) {
          data.policialRecebedorPatio = this.policialSelecionado.id
        }
        service.cadastro(data, this.$route.params.id, GRV_POLICIA_CIVIL).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionar para tela de visualização da grv criada
              this.$router.push({name: 'roubo-furto.visualizar', params: {id: response.data.id}})
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      },
      adicionarLacre () {
        this.data.lacres.push(JSON.parse(JSON.stringify(templateLacre)))
      },
      adicionarArquivo () {
        this.data.arquivos.push(JSON.parse(JSON.stringify(templateArquivo)))
      },
      uploadDocumento (e) {
        const reader = new FileReader()

        const file = e.target.files[0]

        const _this = this
        reader.onloadend = function () {
          const lastPosition = _this.data.arquivos.length - 1
          _this.data.arquivos[lastPosition].arquivo = reader.result
          _this.$el.querySelector(e.target.id).value = ''
        }

        if (file) {
          reader.readAsDataURL(file)
        } else {
          alert('erro na leitura do arquivo')
        }
      },
      marcaEquipamento (e, v) {
        let template = JSON.parse(JSON.stringify(templateEquipamento))
        // this.$set(this.dataRequired.equipamentos[this.dataRequired.equipamentos.indexOf(v)], 'checked', e.target.checked)
        v.checked = e.target.checked
        if (e.target.checked) {
          // template.possui = v.possui
          template = v
          this.$set(template, 'possui', v.possui)
          /* Object.defineProperty(template, 'possui', {
            get () {
              return template.possui
            }
          }) */
          // delete template.equipamento.possui
          this.data.equipamentos.push(template)
        } else {
          this.data.equipamentos = this.data.equipamentos.filter((e) => {
            // return e.equipamento.id !== v.id
            return e.id !== v.id
          })
        }
        console.log(this.data.equipamentos)
      },
      getThumbUrl (img = '') {
        return `${process.env.API_URL.replace('/app_dev.php', '')}/grv-fotos-thumbs/${this.data.numero}/${img && img.replace(/(.jpg$)/, '-thumb$1')}`
      },
      consultaPlacaChassi () {
        // console.log('placa ' + this.data.placa)
        // if (this.data.placa) {
        //   console.log('placa: ' + this.data.placa)
        // } else {
        //   console.log('chassi: ' + this.data.chassi)
        // }
        console.log(this.data)
        this.$loaderOverlay.open().message('Carregando dados do veículo')

        service.consultaPlacaChassi(this.data)
          .then((response) => {
            console.log(response)
            this.$loaderOverlay.hide()
            // result = JSON.parse(response.data)
            let data = JSON.parse(response.data)
            if (data.Retorno === 'OK') {
              this.data.placa = data.Placa
              this.data.chassi = data.Chassi
              this.data.marca = data.DescricaoMarca
              this.data.modelo = data.DescricaoTipo
              this.data.cor = data.DescricaoCor
              this.data.renavam = data.NumeroRenavam
              this.data.ano = data.AnoFabricacao

              if (data.Classificacao === 'LA') {
                this.data.bemCategoria = 1
              } else if (data.Classificacao === 'LB') {
                this.data.bemCategoria = 2
              } else if (data.Classificacao === 'LC') {
                this.data.bemCategoria = 3
              } else if (data.Classificacao === 'PD') {
                this.data.bemCategoria = 4
              }
            } else {
              alert(data.Retorno)
            }
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            alert(response.Retorno)
          })
      },
      openFormPericia () {
        this.showFormPericia = true
      },
      closeFormPericia: async function (forceUpdate = false) {
        if (forceUpdate) {
          const _this = this

          this.$loaderOverlay.open().message('Processando...')

          await updatePlacaAlterada(_this.data.id, {}).catch(error => {
            alert('Ocorreu um erro ao atualizar a placa alterada')
            console.log(error)
          })

          this.start()
        }
        this.showFormPericia = false
      },
      openFormPolicial () {
        this.showFormPolicial = true
      },
      closeFormPolicial () {
        this.carregarPoliciais()
        this.showFormPolicial = false
      },
      setPolicialSelecionado (evt, id = null) {
        if (id === null) {
          return
        }
        const found = this.policiais.find(policial => policial.id === id)
        this.policialSelecionado = found ? JSON.parse(JSON.stringify(found)) : null
      },
      carregarPatentes () {
        PatenteService.list(10000, 1, '')
          .then(response => {
            this.patentes = response.data.arrayData
          })
          .catch(error => {
            alert('Erro ao carregar as patentes')
            console.log(error)
          })
      },
      carregarUnidadesPoliciais () {
        UnidadePolicialService.list(10000, 1, '')
          .then(response => {
            this.unidadesPoliciais = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar as unidades policiais')
            console.log(error)
          })
      },
      carregarSeguradoras () {
        SeguradoraService.list(10000, 1, '')
          .then(response => {
            this.seguradoras = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar as unidades policiais')
            console.log(error)
          })
      },
      carregarPoliciais (filtro = null, unique = false) {
        if (unique) {
          PolicialService.find(filtro)
            .then(response => {
              this.policialSelecionado = response.data
            })
            .catch(error => {
              alert('Erro ao carregar policial')
              console.log(error)
            })
        } else {
          PolicialService.list(10000, 1, `&busca=${filtro}`)
            .then(response => {
              this.policiais = response.data.result
              this.loading = false
            })
            .catch(error => {
              alert('Erro ao carregar lista de policiais')
              console.log(error)
            })
        }
      },
      carregarAtendentesPatio () {
        AtendentePatioService.list(10000, 1, '')
          .then(response => {
            this.atendentesPatio = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar lista de atendentes de pátio')
            console.log(error)
          })
      },
      carregarTiposGrv () {
        TiposGrvService.list(10000, 1, '')
          .then(response => {
            this.tiposGrv = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar lista de tipos de grv')
            console.log(error)
          })
      },
      carregarReintegradoras () {
        ReintegradoraService.list(10000, 1, '')
          .then(response => {
            this.reintegradoras = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar lista de reintegradoras')
            console.log(error)
          })
      },
      carregarLocadoras () {
        LocadoraService.list(10000, 1, '')
          .then(response => {
            this.locadoras = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar lista de locadoras')
            console.log(error)
          })
      },
      carregarTiposDevolucao () {
        TiposDevolucaoService.list(10000, 1, '')
          .then(response => {
            this.tiposDevolucao = response.data.arrayData
          })
          .catch(error => {
            alert('Erro ao carregar lista de tipos de devolução')
            console.log(error)
          })
      },
      carregarSituacoesApreensao () {
        SituacaoApreensaoService.list(10000, 1, '')
          .then(response => {
            this.situacoesApreensao = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar lista de situações de apreensão')
            console.log(error)
          })
      },
      carregarAvarias () {
        AvariaService.list(10000, 1, '')
          .then(response => {
            this.avarias = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar lista de avarias')
            console.log(error)
          })
      },
      carregarEstadosVeiculo () {
        EstadoVeiculoService.list(10000, 1, '')
          .then(response => {
            this.estadosVeiculo = response.data.arrayData
          })
          .catch(error => {
            alert('Erro ao carregar lista de estados de veículo')
            console.log(error)
          })
      },
      getListaPoliciais: debounce(function () {
        this.policiais = []
        this.loading = true
        const filtro = this.filtro.trim()
        if (filtro) {
          this.setVisibilityOptionsAutocomplete(true)
          this.carregarPoliciais(filtro)
        } else {
          // this.policialSelecionado = null
          this.loading = false
          this.setVisibilityOptionsAutocomplete(false)
        }
      }, 300),
      setVisibilityOptionsAutocomplete (status) {
        setTimeout(() => {
          this.showOptionsAutocomplete = status
        }, 100)
      }
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition" v-if="dataRequiredLoaded">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-warning lter b-b wrapper-md" v-if="isGgv">
              <div class="row">
                <div class="col-xs-12">
                  <h1 class="font-thin h3 text-black">
                    <strong>GGV</strong><br>
                    Você está fazendo a vistoria para guarda deste veículo
                  </h1>
                </div>
              </div>
            </div>
          </div>

          <div class="panel panel-default">
            <div class="clearfix">
              <div>
                <form v-on:submit.prevent="submit" class="bs-example form-horizontal form-grv">
                  <div class="wrapper">
                    <div class="panel-body">
                      <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
                        <div class="m-b-sm font-bold">Erro ao registrar a GRV, corrija e tente novamente</div>
                        <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
                      </div>
                      <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
                      <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null" class="alert alert-success">
                        <div class="font-bold">Atualizado com sucesso!</div>
                      </div>
                      <div class="col-sm-12 col-xs-12 m-b" v-if="data.id">
                        <h1 class="font-thin h3"></h1>
                      </div>

                      <div class="form-group">
                        <label for="dataEntradaPatio" class="col-sm-2 control-label">Data/Hora Entrada no Pátio</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="dataEntradaPatio" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'" v-model="data.dataEntradaPatio"/>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label for="recebedorPatio" class="col-sm-4 control-label">Recebedor Pátio</label>
                                <div class="col-sm-8">
                                  <select id="recebedorPatio" v-model="data.recebedorPatio" class="form-control">
                                    <option :value="null">Selecione</option>
                                    <option :value="atendente.id" v-for="atendente in dataRequired.atendentesPatio" :key="atendente.id" :disabled="!atendente.ativo">
                                      {{atendente.nome}} <span style="font-size: small; color: red" v-if="!atendente.ativo">(inativo)</span>
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="dataSaidaPatio" class="col-sm-2 control-label">Data/Hora Saída do Pátio</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="dataSaidaPatio" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'" v-model="data.dataSaidaPatio"/>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label class="col-sm-4 control-label">Policial Recebedor Pátio</label>
                                <div class="col-sm-8">
                                  <!-----------------------TODO: Transformar em componente--------------------->
                                  <div class="autocomplete-input">
                                    <input class="form-control" type="text" @blur="setVisibilityOptionsAutocomplete(false)" @keyup="getListaPoliciais" v-model="filtro" placeholder="Digite o nome ou matrícula do policial para pesquisar...">
                                    <ul class="list-group" v-show="showOptionsAutocomplete">
                                      <li class="text-center" v-if="loading"><i class="fa fa-spinner fa-spin"></i></li>
                                      <li class="text-danger" v-else-if="!policiais.length">Policial não encontrado no sistema</li>
                                      <li @click="setPolicialSelecionado($event, policial.id)" v-for="policial in policiais" :key="policial.id" v-else>
                                        {{policial.nome}} - {{policial.matricula}} <small class="text-danger" v-if="!policial.ativo">(Inativo)</small>
                                      </li>
                                    </ul>
                                  </div>
                                  <!---------------------------------------------------------------------------->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="tipoRemocao" class="col-sm-2 control-label">Tipo GGV</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <select id="tipoRemocao" v-model="data.tipoGgv" class="form-control">
                                <option :value="null" disabled>Selecione</option>
                                <option :value="tipo.id" v-for="tipo in dataRequired.tiposGrv">{{tipo.nome}}</option>
                              </select>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label for="matriculaPolicialRecebedorPatio" class="col-sm-2 control-label"></label>
                                <div class="col-sm-7">
                                  <input id="nomePolicialRecebedorPatio" v-model="policialSelecionado.nome" type="text" class="form-control" disabled/>
                                </div>
                                <div class="col-sm-3">
                                  <input id="matriculaPolicialRecebedorPatio" v-model="policialSelecionado.matricula" type="text" class="form-control" disabled/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="estadoVeiculo" class="col-sm-2 control-label">Estado do veículo</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <select id="estadoVeiculo" v-model="data.estadoVeiculo" class="form-control">
                                <option :value="null" disabled>Selecione</option>
                                <option :value="estado.id" v-for="estado in dataRequired.estadosVeiculo">{{estado.nome}}</option>
                              </select>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label for="unidadePolicial" class="col-sm-4 control-label">Unidade Policial</label>
                                <div class="col-sm-8">
                                  <select id="unidadePolicial" class="form-control" v-model="data.unidadePolicialRecebedorPatio">
                                    <option :value="null">Selecione</option>
                                    <option :value="unidadePolicial.id" v-for="unidadePolicial in dataRequired.unidadesPoliciais" :key="unidadePolicial.id">
                                      {{unidadePolicial.nome}}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label for="trancado" class="i-checks m-b-none">
                            <input v-model="data.trancado" type="checkbox" id="trancado"
                                   tabindex="0" aria-checked="false"
                                   aria-invalid="false"><i></i>
                          </label>
                          <label for="trancado">Trancado</label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label for="comChave" class="i-checks m-b-none">
                            <input v-model="data.comChave" type="checkbox" id="comChave"
                                   tabindex="0" aria-checked="false"
                                   aria-invalid="false"><i></i>
                          </label>
                          <label for="comChave">Com Chave</label>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="observacoesGgv" class="col-sm-2 control-label">Observações GGV</label>
                        <div class="col-sm-10">
                          <textarea id="observacoesGgv" v-model="data.observacoesGgv" rows="7" class="form-control" style="resize: none;"></textarea>
                        </div>
                      </div>
                    </div><!-- END Padding -->
                  </div>

                  <!---->
                  <div class="wrapper">
                    <div class="panel-body">
                      <hr>
                      <h4>Equipamentos / Acessórios</h4>

                      <div class="form-group b-b padder-v" v-for="equip in dataRequired.equipamentos" :key="equip.id">
                        <div class="col-sm-offset-2 col-sm-10">
                          <div class="row">
                            <div class="col-xs-4">
                              <label class="i-checks m-b-none">
                                <input v-model="equip.checked" @change="marcaEquipamento($event, equip)" type="checkbox"
                                       :id="equip.id"
                                       tabindex="0"
                                       aria-checked="false"
                                       aria-invalid="false"><i></i>
                              </label>
                              <label :for="equip.id">{{equip.nome}}</label>
                            </div>
                            <div class="col-xs-4 form-inline" v-show="equip.checked">
                              <label>Avaria: </label>
                              <select class="form-control" v-model="equip.avaria">
                                <option :value="null" disabled selected>Nenhum</option>
                                <option :value="avaria.id" v-for="avaria in dataRequired.avarias" :key="avaria.id">{{avaria.nome}}</option>
                              </select>
                            </div>
                            <div class="col-xs-4" v-show="false">
                              <btn-check-possui v-model="equip.possui" v-show="equip.checked"/>
                            </div>
                          </div>
                        </div>
                      </div><!---->
                    </div>
                  </div>

                  <div class="bg-light lter b-b wrapper-md" v-if="isGgv">
                    <div class="row">
                      <div class="col-sm-6 col-xs-12">
                        <h2 class="font-thin h3">
                          Parecer Final
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div class="wrapper-md m-b-lg" v-if="isGgv">
                    <div class="row">
                      <label class="col-sm-4 control-label">Em conformidade com a GRV</label>
                      <div class="col-sm-8">
                        <select v-model="ggv.conforme" class="form-control">
                          <option :value="true">Conforme</option>
                          <option :value="false">Não conforme</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="wrapper" v-if="!isGgv">
                    <div class="panel-body">
                      <div class="row">
                        <button class="btn btn-success btn-md m-l-xs btn-colsultaGrv">Salvar</button>
                        <button class="btn btn-info btn-md m-l-xs btn-colsultaGrv">Salvar e adicionar outro(a)</button>
                        <button class="btn btn-info btn-md m-l-xs btn-colsultaGrv">Salvar e continuar editando</button>

                        <button v-if="edit" class="btn btn-danger btn-md m-l-xs btn-colsultaGrv pull-right">Apagar
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="wrapper" v-else>
                    <div class="panel-body">
                      <div class="row">
                        <button class="btn btn-success btn-block btn-lg">Confirmar GGV</button>
                        <div class="text-center">* a confirmação inclui imeditamente este bem no pátio e transmite as
                          informações para o DETRO
                        </div>
                      </div>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  .form-grv label {
    cursor: pointer;
  }

  .btn-colsultaGrv {
    padding-top: 7px;
    padding-bottom: 7px;
  }

  /* Raphael */
  .autocomplete-input {
    position: relative;
  }
  .autocomplete-input input {
    width: 100%;
    height: 100%;
  }
  .autocomplete-input ul {
    position: absolute;
    border: #999 1px solid;
    list-style-type: none;
    width: 100%;
    max-height: 80px;
    overflow: auto;
    background-color: #fff;
    z-index: 99;
  }
  .autocomplete-input ul li {
    padding: 5px;
    cursor: pointer;
  }
  .autocomplete-input ul li:hover {
    background-color: #fff;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// Ggv.vue?4ddff895